// ** React Imports
import { lazy } from 'react'

const KpisIndex = lazy(() => import('../../views/kpis/list'))

const Kpis = [
  {
    path: '/kpis/list',
    element: <KpisIndex/>
  }
]

export default Kpis